module.exports = __webpack_public_path__ + "img/bgbottom.c661e0bf.png";